<template >
    <div id="auxModal" class="modal fade " tabindex="-1" aria-hidden="true" >
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ $t('key_title_aux') }}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
      </div>
      <div class="modal-body">
        <div>
            <label class="text-primary">{{ $t('key_title_aux1') }}</label>
            <input  v-model="localValue.aux1" class="form-control" type="text" maxLength="50" />
        </div>
        <div>
            <label class="text-primary">{{ $t('key_title_aux2') }}</label>
            <input v-model="localValue.aux2" class="form-control" type="text" maxLength="50" />
        </div>
        <div>
            <label class="text-primary">{{ $t('key_title_aux3') }}</label>
            <input v-model="localValue.aux3" class="form-control" type="text" maxLength="50" />
        </div>
        <div>
            <label class="text-primary">{{ $t('key_title_aux4') }}</label>
            <input v-model="localValue.aux4" class="form-control" type="text" maxLength="50" />
        </div>
        <div>
            <label class="text-primary">{{ $t('key_title_aux5') }}</label>
            <input v-model="localValue.aux5" class="form-control" type="text" maxLength="50" />
        </div>
      </div>
      <div class="modal-footer">
        <button id="close" type="button" class="btn  btn-outline-primary" data-bs-dismiss="modal">{{ $t('key_close') }}</button>
        <button type="button" class="btn bg-gradient-success" @click="guardar">{{ $t('key_submit') }}</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
    components: {
    },
    props: {
        variant: {
            type: Object,
            required: true,
            default: () => {
                return {};
            },
        },
    },
    emits: ['aux-changed'],
    data() {
        return {
            localValue: this.variant,
        }
    },
    watch: {
        variant(val) {
            this.localValue = { ...val};
        },
    },
    mounted () {
        this.localValue= this.variant;
    },
    methods: {
        hideModal() {
            document.getElementById('close').click();
        },
        guardar(){
            this.$emit('aux-changed', this.localValue);
            this.hideModal();
        }
    },

};
</script>